import { ReactElement } from 'react';
import styled from 'styled-components';

import { Spinner } from '@creditornot/cb-progress';

import { ContentContainer } from './ContentContainer';

const Root = styled(ContentContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const PageSpinner = (): ReactElement => {
  return (
    <Root>
      <Spinner size="extraLarge" />
    </Root>
  );
};
